var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNeet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1236_2324)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_1236_2324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.175 18.0265C26.4375 18.814 26.0109 19.6624 25.2281 19.9249L24 20.3328V25.9999C24 28.4843 26.0156 30.4999 28.5 30.4999C30.9844 30.4999 33 28.4843 33 25.9999V20.3328L31.7766 19.9249C30.9891 19.6624 30.5672 18.814 30.8297 18.0265C31.0922 17.239 31.9406 16.8171 32.7281 17.0796L33.9516 17.4874C35.175 17.8953 36 19.039 36 20.3328V25.9999C36 29.6187 33.4406 32.6375 30.0328 33.3453C30.3281 35.9656 32.55 37.9999 35.25 37.9999C38.1516 37.9999 40.5 35.6515 40.5 32.7499V29.4359C39.1734 28.8593 38.25 27.5374 38.25 25.9999C38.25 23.9281 39.9281 22.2499 42 22.2499C44.0719 22.2499 45.75 23.9281 45.75 25.9999C45.75 27.5374 44.8266 28.8593 43.5 29.4359V32.7499C43.5 37.3062 39.8062 40.9999 35.25 40.9999C30.8953 40.9999 27.3328 37.6296 27.0234 33.3546C23.5875 32.6656 21 29.6374 21 25.9999V20.3328C21 19.0437 21.825 17.8953 23.0531 17.4874L24.2766 17.0796C25.0641 16.8171 25.9125 17.2437 26.175 18.0265ZM42 27.4999C42.8279 27.4999 43.5 26.8278 43.5 25.9999C43.5 25.1721 42.8279 24.4999 42 24.4999C41.1721 24.4999 40.5 25.1721 40.5 25.9999C40.5 26.8278 41.1721 27.4999 42 27.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1236_2324",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1236_2324"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1236_2324"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1236_2324"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1236_2324",
    result: "effect2_dropShadow_1236_2324"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1236_2324",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_2324",
    x1: 5,
    y1: 1,
    x2: 61,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A34A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNeet);
export default __webpack_public_path__ + "static/media/ic_neet.75653e645d3f3c0f758f7e7f681432b3.svg";
export { ForwardRef as ReactComponent };